module.exports = __webpack_public_path__ + "img/img-ff562b.png";